var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntelligentgraphicIconBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L19.0632911,0 C20.1678606,-2.02906125e-16 21.0632911,0.8954305 21.0632911,2 L21.0632911,26.7341772 L21.0632911,26.7341772 L2,26.7341772 C0.8954305,26.7341772 1.3527075e-16,25.8387467 0,24.7341772 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-471.000000, -6160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-22",
    transform: "translate(471.000000, 6160.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-31",
    transform: "translate(6.650000, 8.700000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u77E9\\u5F62",
    fill: "#FE5454",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3924051,7.57753165 C15.9446898,7.57753165 16.3924051,8.0252469 16.3924051,8.57753165 C16.3924051,9.09036748 16.0063649,9.51303881 15.5090262,9.57080391 L15.3924051,9.57753165 L10.5316456,9.57753165 C9.97936082,9.57753165 9.53164557,9.1298164 9.53164557,8.57753165 C9.53164557,8.06469581 9.91768576,7.64202448 10.4150244,7.58425938 L10.5316456,7.57753165 L15.3924051,7.57753165 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93473101,7.57753165 C7.48701576,7.57753165 7.93473101,8.0252469 7.93473101,8.57753165 C7.93473101,9.09036748 7.54869082,9.51303881 7.05135214,9.57080391 L6.93473101,9.57753165 L6.22310127,9.57753165 C5.67081652,9.57753165 5.22310127,9.1298164 5.22310127,8.57753165 C5.22310127,8.06469581 5.60914146,7.64202448 6.10648014,7.58425938 L6.22310127,7.57753165 L6.93473101,7.57753165 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7143987,13.653481 C11.2666835,13.653481 11.7143987,14.1011963 11.7143987,14.653481 C11.7143987,15.1663169 11.3283585,15.5889882 10.8310199,15.6467533 L10.7143987,15.653481 L6.03639241,15.653481 C5.48410766,15.653481 5.03639241,15.2057658 5.03639241,14.653481 C5.03639241,14.1406452 5.4224326,13.7179739 5.91977128,13.6602087 L6.03639241,13.653481 L10.7143987,13.653481 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FF9A4A",
    x: 12.9620253,
    y: 14.5822785,
    width: 19.0379747,
    height: 14.5822785,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9451915,22.5992437 C18.9639919,20.5898435 22.1871524,20.5383204 24.430753,22.6179519 L24.605841,22.7865641 C26.340284,24.5210072 28.0742107,25.4400489 29.8170793,25.589079 C30.367356,25.6361323 30.7752991,26.1203639 30.7282458,26.6706406 C30.6811925,27.2209173 30.1969609,27.6288604 29.6466842,27.5818071 C27.3926134,27.389065 25.237775,26.2469253 23.1916274,24.2007777 C21.6606363,22.6697865 19.2762417,22.6697865 15.8396187,24.3880981 C15.3456402,24.6350873 14.7449671,24.434863 14.4979779,23.9408845 C14.2509886,23.446906 14.451213,22.8462329 14.9451915,22.5992437 Z",
    id: "\\u8DEF\\u5F84-41",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFFFFF",
    cx: 26.9367089,
    cy: 19.3715562,
    r: 1.41772152
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentgraphicIconBig);
export default __webpack_public_path__ + "static/media/Intelligentgraphic_icon_big.763e6b9278a4abcb0b7486536b2588ff.svg";
export { ForwardRef as ReactComponent };